import styles from 'css/src/components/common/email-capture/EmailCaptureInline.module.scss';

import React from 'react';

import type { EmailCaptureForm } from 'js/src/components/common/email-capture/email-capture-consts';
import HubSpotForm from 'js/src/components/common/email-capture/HubSpotForm';

type EmailCaptureInlineProps = {
    message: string;
    form: EmailCaptureForm;
    className?: string;
    onFormSubmitted?: VoidFunction;
};

const EmailCaptureInline: React.FC<EmailCaptureInlineProps> = React.memo(
    function EmailCaptureInline({ message, form, className, onFormSubmitted }) {
        return (
            <section
                className={`${styles['email-capture-inline']} ${className ?? ''}`}
                aria-label="Newsletter sign up"
            >
                <p className={styles['email-capture-inline__message']}>{message}</p>
                <HubSpotForm
                    className={styles['email-capture-inline__form']}
                    portalId={form.portalId}
                    formId={form.formId}
                    region={form.region}
                    onFormSubmitted={onFormSubmitted}
                />
            </section>
        );
    },
);

export default EmailCaptureInline;
